/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import React from 'react';
import { getReportViewerHeaderDetails } from './store/action/reportViewerAction';
import serviceCall from './store/serviceCall/index';
import { ToasterMessage } from './components/sharedComponents';
import { groupChecklistFilterByReportStatus } from './utils/filter';

export const appVersion = '4.10.0';

export const apiRouter = {
  APIURL: process.env.REACT_APP_ONYX_API_ENDPOINT,
};

export const callBackUrl = {
  url: process.env.REACT_APP_ONYX_WEBAPP_ENDPOINT,
};

export const regularExpression = {
  Email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{1,2}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  Password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,150}$/,
  Phone: /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/,
};

// Strings
export const FEATURE_TASK_COMPLETION_STATUS = 'task_completion_status';

export const DEFAULT_MOMENT_DATE_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_DEVEXPRESS_DATE_FORMAT = 'MM/dd/yyyy';

export const sidenavatag = '.sidenavatag';
export const reportViewserUpdateReport = 'ReportViewer/UpdateReport';
export const noMoreData = 'No more data';
export const getChecklistWorkPlanForReport =
  'checklists/GetChecklistWorkPlanForReport';
export const sqlLiteFileSuccess = 'SqlLite file imported successfully';
export const sqlLiteFileError = 'SqlLite file failed to import';
export const updateAssesmentDetails = 'reportviewer/UpdateAssesmentDetails';
export const getIssueChartModelComponentSeverityCount =
  'Issues/GetIssueChartModelComponentSeverityCount';
export const getIssueDetails = 'Issues/GetIssueDetails';
export const pageBreak = 'page-break';
export const activesidebar = '.activesidebar';
export const iconwhite = '.iconwhite';
export const dxdrawerpanelcontent = '.dx-drawer-panel-content';
export const companyAdmin = 'Company Admin';
export const supportAdmin = 'Support Admin';
export const headerComponent = '.headerComponent';
export const selectAChecklist = 'Select a Checklist';
export const selectAWorkplan = 'Select a Workplan';
export const inspectionSummary = 'Inspection Summary';
export const breakWord = 'break-word';
export const applicationJson = 'application/json';
export const inlineBlock = 'inline-block';
export const pressureUnits = 'Pressure Units';
export const timerUnits = 'Timer Units';
export const pumpPress = 'Pump Press';
export const freqTimer = 'Freq Timer';
export const inPROGRESS = 'IN PROGRESS';
export const serialNo = 'Serial No.';
export const siteNotApproved = 'SITE NOT APPROVED FOR DELIVERIES TO COMMENCE';
export const requiredDocumentation =
  'Required documentation to prepare the technical inspection';
export const documentationAvailable = 'Documentation available on site';
export const documentsAndComponents = 'Documents and Components';
export const componentsArea = 'Components / Area';
export const minTemperature = 'Min Temperature';
export const currentTemperature = 'Current Temperature';
export const maxTemperature = 'Max Temperature';
export const technicalAdviser = 'Technical Adviser ("TA") WPO';
export const manufacturerRepresentative = 'Manufacturer representative';
export const windSpeed = 'Wind speed';
export const clientRepresentative = 'Client representative';
export const locationWindTurbine = 'Location of the wind turbine';
export const OtherCompany = 'Other company';
export const conclusionChoice1 = 'conclusion choice1';
export const conclusionChoice2 = 'conclusion choice2';
export const conclusionChoice3 = 'conclusion choice3';
export const conclusionChoice4 = 'conclusion choice4';
export const conclusionChoice5 = 'conclusion choice5';
export const poorCondition = 'Poor condition';
export const lubePanelCheck = 'Lube Panel Check';
export const newAssembly = 'New Assembly';
export const newComponent = 'New Component';
export const newChecklist = 'New Checklist';
export const newSection = 'New Section';
export const modelInfo = 'model info';
export const completedProjects = 'completed projects';
export const checklistTemplate = 'checklist template';
export const adjustTreeview = '#Adjust-Treeview .dx-scrollable-container';
export const cannotMove =
  'Cannot move (the source and destination are the same)';
export const commissioningDate = 'Commissioning date';
export const modelReference = '.modelreference';
export const notAssigned = 'Not Assigned';
export const checklistTasksid =
  'ChecklistTasks/GetAdditionalDataByChecklistTaskId';
export const tagsgetallappliedFailureModes = 'Tags/GetAllAppliedFailureModes';
export const checkLists = 'Checklists/GetInfoBlockByChecklistId';
export const namemustbeUnique = 'Name must be unique';
export const checklistgetadditiondatabyChecklistId =
  'Checklists/GetAdditionalDataByChecklistId';
export const floatrightPointerDisable = 'float-right pointerdisable';
export const floatRight = 'float-right';
export const somethingwentWrong = 'Something went wrong';
export const positiveText = 'Positive Text';
export const defaultValue = 'Default value';
export const failureMode = 'Failure mode';
export const getissueDetails = 'Issues/GetIssueDetails';
export const getissuechartmodelComponentSeverityCount =
  'Issues/GetIssueChartModelComponentSeverityCount';
export const superAdmin = 'Super Admin';
export const RequestFailed = 'Request failed with status code 506';
export const siteApprovedForDeliveriesToCommence =
  'SITE APPROVED FOR DELIVERIES TO COMMENCE';
export const nothingToCopy = 'Nothing to Copy';
export const nothingToExport = 'Nothing to Export';
export const characterLimitReached = 'Character limit reached.';
export const reportTitleRequired = 'Report title is required.';
// it Should be seconds only
export const maxAge = 86400;
export const responseOkCode = 200;
export const two = 2;
export const twenty = 20;
export const five = 5;
export const fifty = 50;
export const zeroPointFive = 0.5;
export const six = 6;
export const seven = 7;
export const sixZero = 60;
export const n100 = 100;
export const twoThousandFiveHundread = 2500;
export const n1000 = 1000;
export const twoThousand = 2000;
export const n3000 = 3000;
export const n4000 = 4000;
export const n10484560 = 10484560;
export const n1048576 = 1048576;
export const n13 = 13;
export const n15 = 15;
export const n16 = 16;
export const n17 = 17;
export const n3 = 3;
export const n4 = 4;
export const n9 = 9;
export const n25 = 25;
export const n30 = 30;
export const n32 = 32;
export const n35 = 35;
export const n48 = 48;
export const n55 = 55;
export const n61 = 61;
export const n67 = 67;
export const n68 = 68;
export const n70 = 70;
export const n86 = 86;
export const n200 = 200;
export const n201 = 201;
export const n204 = 204;
export const n208 = 208;
export const n255 = 255;
export const n350 = 350;
export const n404 = 404;
export const n500 = 500;
export const n506 = 506;
export const n171 = 171;
export const n1024 = 1024;
export const n10000000 = 10000000;
export const hundread = 100;
export const ten = 10;
export const thirtyFive = 35;
export const thirtysix = 36;
export const colorHex16 = 16;
export const Messages = {};
export const PdfSizeLimitBytes = 10000000000; // 10 GB

export const maxReportSyncCount = 5000;

// For the filter dialog we ignore checklists with the 'in progress' and 'stock' status.
export const allowedChecklistReleaseStatuses = [
  'in_review',
  'approved',
  'archived',
];

const status = [
  inPROGRESS,
  'IN REVIEW',
  'APPROVED',
  'ARCHIVED',
  'FORCIBILY ARCHIVED',
];
export const ReportContentArea = {
  ReportInformation: 'report_information',
  ReportComments: 'report_comments',
  ReportConclusions: 'report_conclusions',
  ReportSeverityRatingList: 'severity_rating_list',
  ReportPartsList: 'parts_list',
  ReportIssueSummary: 'issue_summary',
  ReportIssueSummaryIncludeStatus: 'issue_summary_include_status',
  ReportSectionsTasks: 'report_sections_tasks',
  ReportSections: 'report_sections',
  ReportTasks: 'report_tasks',
  ReportCustomerDistribution: 'customer_report_distribution_list',
  ReportPartsUsage: 'parts_usage',
  REPORT_INFORMATION_CASTROL: 'report_information_castrol',
  REPORT_INFORMATION_CASTROL_PDI: 'report_information_castrol_pdi',
  REPORT_INFORMATION_WPO: 'report_information_wpo',
};
export const openReport = reportUuid => {
  if (window.location.port) {
    window.open(
      `${window.location.protocol}//${window.location.hostname}:${window.location.port}/#/reportViewer/${reportUuid}`,
    );
  } else {
    window.open(
      `${window.location.protocol}//${window.location.hostname}/#/reportViewer/${reportUuid}`,
    );
  }
};

export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

export const filterResponseCommonentFun = (
  tagFilter,
  severityReport,
  equipReport,
  modelReport,
  checklistReport,
  filterReport,
  filterResponse,
  filterPreference,
  setTagsFilter,
  setEquipmentFilter,
  setModelFilter,
  setChecklistFilter,
  setReportFilter,
  setSeverityFilter,
  setFilterData,
  filterData,
  setActiveFilterData,
  activeFilterData,
) => {
  if (
    tagFilter &&
    severityReport &&
    equipReport &&
    modelReport &&
    checklistReport &&
    filterReport &&
    filterResponse
  ) {
    const SelectedTagFilter = [];
    const ActiveTagFilter = [];
    const SelectedEquipFilter = [];
    let ActiveEquipFilter = [];
    const SelectedModelFilter = [];
    let ActiveModelFilter = [];
    let SelectedChecklistFilter = [];
    let ActiveChecklistFilter = [];
    const SelectedReportFilter = [];
    const ActiveReportFilter = [];
    const SelectedSeverityFilter = [];
    const ActiveSeverityFilter = [];
    if (tagFilter) {
      if (filterPreference?.tagFilter) {
        let tagFilterTemp = tagFilter;
        filterPreference.tagFilter.forEach(selectedTag => {
          tagFilterTemp = tagFilterTemp.map(tag => {
            if (selectedTag.pkId === tag.pkId) {
              tag.selected = true;
            }
            return tag;
          });
          SelectedTagFilter.push(selectedTag.pkId);
          ActiveTagFilter.push(selectedTag);
        });
        setTagsFilter(tagFilterTemp);
      } else {
        setTagsFilter(tagFilter);
      }
    }
    if (equipReport) {
      let equipstr = JSON.stringify(equipReport);
      equipstr = equipstr.replace(/targetEquipments/g, 'items');
      let equipResult = JSON.parse(equipstr);
      if (filterPreference?.equipFilter) {
        filterPreference.equipFilter.forEach(selectedEquip => {
          equipResult = equipResult.map(site => {
            site.items = site.items.map(equip => {
              if (selectedEquip.pkId === equip.pkId) {
                equip.selected = true;
                SelectedEquipFilter.push(selectedEquip.pkId);
              }
              return equip;
            });
            return site;
          });
        });
        ActiveEquipFilter = filterPreference.activeEquipFilter;
        setEquipmentFilter(equipResult);
      } else {
        setEquipmentFilter(equipResult);
      }
    }
    if (modelReport) {
      let modelstr = JSON.stringify(modelReport);
      modelstr = modelstr.replace(/modelAssembly/g, 'items');
      modelstr = modelstr.replace(/modelComponents/g, 'items');
      let modelResult = JSON.parse(modelstr);
      if (filterPreference?.modelFilter) {
        filterPreference.modelFilter.forEach(selectedComponent => {
          modelResult = modelResult.map(model => {
            model.items = model.items.map(assembly => {
              assembly.items = assembly.items.map(component => {
                if (selectedComponent.pkId === component.pkId) {
                  component.selected = true;
                  SelectedModelFilter.push(component.pkId);
                }
                return component;
              });
              return assembly;
            });
            return model;
          });
        });
        ActiveModelFilter = filterPreference.activeModelFilter;
        setModelFilter(modelResult);
      } else {
        setModelFilter(modelResult);
      }
    }

    if (checklistReport) {
      let liststr = JSON.stringify(checklistReport);
      liststr = liststr.replace(/checklistSections/g, 'items');
      liststr = liststr.replace(/checklistTasks/g, 'items');
      let chListResult = JSON.parse(liststr);

      if (filterPreference?.checklistFilter) {
        SelectedChecklistFilter = filterPreference.checklistFilter;
        ActiveChecklistFilter = filterPreference.activeChecklistFilter;
        setChecklistFilter(filterPreference.checklistTree);
      } else {
        setChecklistFilter(groupChecklistFilterByReportStatus(chListResult));
      }
    }

    if (filterReport) {
      if (filterPreference?.reportFilter) {
        let reportFilterTemp = filterReport;
        filterPreference.reportFilter.forEach(selectedReport => {
          reportFilterTemp = reportFilterTemp.map(report => {
            if (selectedReport.reportUuid === report.reportUuid) {
              report.selected = true;
            }
            return report;
          });
          SelectedReportFilter.push(selectedReport.reportUuid);
          ActiveReportFilter.push(selectedReport);
        });
        setReportFilter(reportFilterTemp);
      } else {
        setReportFilter(filterReport);
      }
    }
    if (severityReport) {
      const Data = SeverityReport(severityReport);
      let severitystr = JSON.stringify(Data);
      severitystr = severitystr.replace(/severityRatingFilters/g, 'items');
      let severityResult = JSON.parse(severitystr);

      if (filterPreference?.severityFilter) {
        filterPreference.severityFilter.forEach(selectedSeverity => {
          severityResult = severityResult.map(parent => {
            parent.items = parent.items.map(child => {
              if (
                child.nameShort.toLowerCase() ===
                  selectedSeverity.nameShort.toLowerCase() &&
                child.nameFull.toLowerCase() ===
                  selectedSeverity.nameFull.toLowerCase() &&
                child.parent === selectedSeverity.setName
              ) {
                child.selected = true;
                SelectedSeverityFilter.push(child);
              }
              return child;
            });
            return parent;
          });
        });
      } else {
        severityResult.forEach(parent => {
          parent.items.forEach(child => {
            if (child.selected) {
              SelectedSeverityFilter.push(child);
            }
          });
        });
      }
      setSeverityFilter(severityResult);
      SelectedSeverityFilter.forEach(item => {
        if (!ActiveSeverityFilter[item.parent]) {
          ActiveSeverityFilter[item.parent] = [];
        }
        const data = {
          setName: item.parent,
          nameShort: item.nameShort,
          nameFull: item.nameFull,
          colorBg: item.colorBg,
          colorFg: item.colorFg,
          displaySeq: item.displaySeq,
          selected: item.selected,
        };

        ActiveSeverityFilter.push(data);
      });
    }
    setFilterData({
      ...filterData,
      tagUuids: SelectedTagFilter,
      equipmentUuids: SelectedEquipFilter,
      reportUuids: SelectedReportFilter,
      modelComponentUuids: SelectedModelFilter,
      checklists: SelectedChecklistFilter,
      severities: [...ActiveSeverityFilter],
      default: false,
    });
    setActiveFilterData({
      ...activeFilterData,
      selectedTag: ActiveTagFilter,
      selectedEquipment: ActiveEquipFilter,
      selectedReport: ActiveReportFilter,
      selectedModel: ActiveModelFilter,
      selectedChecklist: ActiveChecklistFilter,
      selectedSeverity: SelectedSeverityFilter,
    });
    return { ActiveSeverityFilter, SelectedSeverityFilter };
  }
};

export const beforeSendCommonFun = (
  page,
  request,
  setpageSize,
  setColumnFilterData,
  filterData,
  cookies,
  isActive,
  searchText,
  status,
) => {
  request.method = 'POST';
  delete request.params['$inlinecount'];
  delete request.params['$top'];
  setpageSize(
    document.getElementsByClassName('dx-page-size dx-selection')[0].innerText,
  );
  request.params['top'] = document.getElementsByClassName(
    'dx-page-size dx-selection',
  )[0].innerText;
  request.params['$skip'] === undefined
    ? (request.params['skip'] = 0)
    : (request.params['skip'] = request.params['$skip']);
  delete request.params['$skip'];
  request.params['$orderby'] === undefined
    ? (request.params['orderBy'] = 'reportDate desc')
    : (request.params['orderBy'] = request.params['$orderby']);
  setColumnFilterData(request.params.orderBy);
  delete request.params['$orderby'];
  if (page === 'issuePunchList') {
    isActive === 1
      ? (request.params['isActive'] = true)
      : (request.params['isActive'] = false);
  }
  if (page === 'reportPage') {
    request.params['searchText'] = searchText;
    isActive === 1
      ? (request.params['isActive'] = true)
      : (request.params['isActive'] = false);
    request.params['State'] = status;
    if (searchText) {
      filterData.TotalCount = 0;
    } else {
      filterData.TotalCount = filterData.TotalCount ? filterData.TotalCount : 0;
    }
  }

  delete request.params['$filter'];
  request.payload = filterData;
  if (page === 'dataTable') {
    request.headers['Authorization'] = `Bearer ${cookies.get('token', {
      path: '/',
    })}`;
  }
};

export const DefaultTemplateData = {
  en: {
    Report_title: 'Report Title',
    Site_name: 'Site Name',
    Inspection_date: 'Inspection Date',
    Equipment_ID: 'Equipment ID',
    Equipment_type: 'Equipment Type',
    Equipment_Manufacturer: 'Equipment Manufacturer',
  },
  fr: {
    Report_title: 'Titre du rapport',
    Site_name: 'Nom du parc',
    Inspection_date: 'Date de l’inspection',
    Equipment_ID: 'N° Turbine',
    Equipment_type: 'Modèle de la turbine',
    Equipment_Manufacturer: 'Constructeur',
  },
};

export const ColorCheck = color => {
  for (let i = color.length; i < six; i++) {
    color = '0' + color;
  }
  return color;
};

export const ChecklistFilterSelected = checklistFilter =>
  checklistFilter.map(status => ({
    ...status,
    selected: false,
    items: status.items.map(checklistItem => ({
      ...checklistItem,
      selected: false,
      items: checklistItem.items.map(workplanItem => ({
        ...workplanItem,
        selected: false,
      })),
    })),
  }));

export const ReportFilter = reportFilter =>
  reportFilter.map(report => {
    report.selected = false;
    return report;
  });

export const EQpmentFilter = equipmentFilter =>
  equipmentFilter.map(equipment => {
    equipment.selected = false;
    equipment.items = equipment.items.map(item => {
      item.selected = false;
      return item;
    });
    return equipment;
  });

export const ModelFilter = modelFilter =>
  modelFilter.map(model => {
    model.selected = false;
    model.items = model.items.map(assembly => {
      assembly.selected = false;
      assembly.items = assembly.items.map(component => {
        component.selected = false;
        return component;
      });
      return assembly;
    });
    return model;
  });

export const ChecklistFilter = (checklistFilter, value) =>
  checklistFilter.map(model => {
    if (value.pkId === model.pkId) {
      model.selected = false;
      model.items = model.items.map(assembly => {
        assembly.selected = false;
        assembly.items = assembly.items.map(component => {
          component.selected = false;
          return component;
        });
        return assembly;
      });
      return model;
    } else {
      model.items = model.items.map(assembly => {
        if (value.pkId === assembly.pkId) {
          assembly.selected = false;
          assembly.items = assembly.items.map(component => {
            component.selected = false;
            return component;
          });
          return assembly;
        } else {
          assembly.items = assembly.items.map(component => {
            if (value.pkId === component.pkId) {
              component.selected = false;
            }
            return component;
          });
          return assembly;
        }
      });
      return model;
    }
  });

export const SeverityReport = severityReport =>
  severityReport.map(item => {
    item.name = item.setName;
    item.severityRatingFilters = item.severityRatingFilters.map(set => {
      set.name = `${set.nameShort}.${set.nameFull}`;
      set.parent = item.setName;
      delete set.setName;
      return set;
    });
    return item;
  });

export const svrList = severityList => {
  const severity = [];
  severityList.forEach(item => {
    if (!severity[item.parent]) {
      severity[item.parent] = [];
    }
    const data = {
      setName: item.parent,
      nameShort: item.nameShort,
      nameFull: item.nameFull,
      colorBg: item.colorBg,
      colorFg: item.colorFg,
      displaySeq: item.displaySeq,
      selected: item.selected,
    };
    severity.push(data);
  });
  return severity;
};

export const ReportTitle = (reportUuid, title) => (
  <div
    style={{
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }}>
    <a
      href={
        window.location.port
          ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}/#/reportViewer/${reportUuid}`
          : `${window.location.protocol}//${window.location.hostname}/#/reportViewer/${reportUuid}`
      }
      rel="noopener noreferrer"
      target="_blank"
      title={title}>
      {title}
    </a>
  </div>
);

export const updateStatus = (
  props,
  value,
  Updateprocess,
  setWidth,
  dispatch,
  reportId,
  kpisFeatureEnabled,
  setIsUpdatingReportStatus,
  setKpiApprovalDialogOpen,
  setEmailDialogOpen,
) => {
  if (
    value &&
    (parseInt(Updateprocess.currentname + 1, 10) === Updateprocess.indexname ||
      parseInt(Updateprocess.currentname - 1, 10) === Updateprocess.indexname)
  ) {
    setWidth(Updateprocess.indexname);
    props.changePreview(false);

    const releaseStatusMap = {
      [inPROGRESS]: 'in_progress',
      'IN REVIEW': 'in_review',
      APPROVED: 'approved',
      ARCHIVED: 'archived',
    };

    const releaseStatus =
      releaseStatusMap[status[Updateprocess.indexname]] || '';

    const data = {
      reportUuid: reportId,
      releaseStatus,
      applicationUri: window.location.origin,
    };

    setIsUpdatingReportStatus(true);

    serviceCall
      .putDataNew('ReportViewer/UpdateReportStatus', data)
      .then(response => {
        // In the situation where the response is a string, treat this as an error
        if (typeof response === 'string') {
          console.error('API error:', response);
          ToasterMessage('error', response || 'Failed to update report status');
          return;
        }

        // If it's an object and there's no `data`, assume success (200 OK with no body)
        dispatch(
          getReportViewerHeaderDetails(
            `ReportViewer/GetReportViewerHeaderDetails/${reportId}`,
          ),
        );
        ToasterMessage('success', 'Successfully updated report status');
      })
      .catch(error => {
        console.error('Error updating report status:', error);
        ToasterMessage('error', 'Failed to update report status');
      })
      .finally(() => {
        setIsUpdatingReportStatus(false);
        if (releaseStatus === 'approved' && kpisFeatureEnabled) {
          setKpiApprovalDialogOpen(true);
        }
        if (releaseStatus === 'approved' && !kpisFeatureEnabled) {
          setEmailDialogOpen(true);
        }
      });
  }
};

export const customColorPalette = [
  {
    color: '#ffc000',
    label: 'Orange',
  },
  {
    color: '#ff0000',
    label: 'Red',
  },
  {
    color: '#00cc00',
    label: 'Green',
  },
  {
    color: '#ffff00',
    label: 'Yellow',
  },
  {
    color: ' #5e8c31',
    label: 'Maximum green',
  },
  {
    color: 'rgb(0, 153, 255)',
    label: 'Blue',
  },
  {
    color: 'rgb(128, 128, 128)',
    label: 'Grey',
  },
  {
    color: 'hsl(340, 82%, 52%)',
    label: 'Pink',
  },
  {
    color: 'hsl(291, 64%, 42%)',
    label: 'Purple',
  },
  {
    color: 'hsl(262, 52%, 47%)',
    label: 'Deep Purple',
  },
  {
    color: 'hsl(231, 48%, 48%)',
    label: 'Indigo',
  },
  {
    color: '#000000',
    label: 'Black',
  },
  {
    color: '#FFFFFF',
    label: 'White',
  },
  {
    color: '#00FFFF',
    label: 'Aqua',
  },
  {
    color: '#007FFF',
    label: 'Azure',
  },
  {
    color: '#FF00FF',
    label: 'Magenta',
  },
];

// Stings
export const MM_DD_YYYY = 'MM-DD-YYYY';

const isEmptyOrNullOrUndefined = val => ['', null, undefined].includes(val);

const areAllNaN = (n1, n2) => isNaN(n1) && isNaN(n2);

export const areStringsDifferent = (s1, s2) => {
  const s1Cleaned = typeof s1 === 'string' ? s1.trim() : s1;
  const s2Cleaned = typeof s2 === 'string' ? s2.trim() : s2;

  if (typeof s1Cleaned != typeof s2Cleaned) return true;
  if (s1Cleaned !== s2Cleaned) return true;

  if (s1Cleaned === s2Cleaned) return false;

  return (
    !areAllNaN(s1Cleaned, s2Cleaned) &&
    !(
      isEmptyOrNullOrUndefined(s1Cleaned) && isEmptyOrNullOrUndefined(s2Cleaned)
    )
  );
};

export const areNumbersDifferent = (n1, n2) => {
  if (typeof n1 === 'number' && typeof n2 === 'number') {
    return !areAllNaN(n1, n2) && n1 !== n2;
  }
  if (!Number.isFinite(parseFloat(n1)) && !Number.isFinite(parseFloat(n2))) {
    return false;
  }
  return parseFloat(n1) !== parseFloat(n2);
};

/**
 * Compares two report page dates and returns true if they are different.
 * Ideally we shouldn't need this function and the data types should be consisten when comparing updates but there is no time to fix this now.
 *
 * @param {string | number} fieldValue - The first date value, which can be a Unix timestamp or a date string.
 * @param {string | number} modifiedVal - The second date value, which can be a Unix timestamp or a date string.
 * @returns {boolean} - Returns true if the dates are different, otherwise false.
 */
export const areDatesDifferent = (fieldValue, modifiedVal) => {
  if (fieldValue === modifiedVal) {
    return false;
  }

  // Convert fieldValue to YYYY-MM-DD format
  const fieldValueDate = new Date(Number(fieldValue))
    .toISOString()
    .split('T')[0];

  // Convert modifiedVal to YYYY-MM-DD format if it's a Unix timestamp string
  let modifiedDate;

  if (!isNaN(modifiedVal)) {
    modifiedDate = new Date(Number(modifiedVal)).toISOString().split('T')[0];
  } else if (typeof modifiedVal === 'string') {
    modifiedDate = new Date(modifiedVal).toISOString().split('T')[0];
  } else {
    console.error('Unexpected type for modifiedVal:', typeof modifiedVal);
    return false;
  }

  // Compare the dates
  if (fieldValueDate === modifiedDate) {
    return false;
  } else {
    return true;
  }
};

export const acceptableImageFileTypes = [
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
];

export const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export const isEmailValid = emailAddress =>
  emailValidationRegex.test(emailAddress);

export const ROLES = {
  ADMIN: 'Admin',
  COMPANY_ADMIN: 'Company Admin',
  SUPPORT_ADMIN: 'Support Admin',
  SUPER_ADMIN: 'Super Admin',
  MANAGER: 'Manager',
  USER: 'User',
};

export const preloadImage = url => {
  if (!url) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject();
    img.src = url;
  });
};
